module.exports = __webpack_public_path__ + "static/img/7a.cdd0099a.png";